module.exports = __webpack_public_path__ + "static/media/Graphic3.c4c945b7.jpeg";